import Vue from 'vue';
import Vuex from 'vuex';
import screenData from './modules/screens-data.js';
import segmentData from './modules/segments-data.js';
import grapesData from './modules/grapes-data.js';
import imagesData from './modules/images-data.js';
import playersData from './modules/players-data.js';
import dispositionsData from './modules/dispositions-data.js';
import paramsClientData from './modules/paramsClient-data.js';
import routeData from './modules/route-data.js';

import slidesData from './modules/slides-data.js';
import commonData from './modules/common-data.js';
import player from './modules/player';
import mediaData from './modules/medias-data.js';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  modules: {
    player: player,
    slides: slidesData,
    common: commonData,
    grapes: grapesData,
    screens: screenData,
    segments: segmentData,
    dispositions: dispositionsData,
    imagesData,
    playersData,
    paramsClientData,
    routeData,
    medias: mediaData,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js